export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      functionName: "見守り機能",
      locationNumber: "location-00003",
      nickName: "アイラ3号",
      answeredAt: 1234567890123,
      answer: "良いです",
      responseStatus: 2,
      responseNote: "note test"
    }
  }
}